export default "__VITE_ASSET__diUwawnc__"